import { OrderedList as OrderedListExtension } from '@tiptap/extension-ordered-list';
import { CustomListItemExtensionName, CustomOrderedListExtensionName } from './utils/names';

export const CustomOrderedList = OrderedListExtension.extend({
  name: CustomOrderedListExtensionName,

  addOptions() {
    return {
      itemTypeName: CustomListItemExtensionName,
      HTMLAttributes: {},
      keepMarks: true,
      keepAttributes: true,
    };
  },
});
